import { render, staticRenderFns } from "./LoginAccount.vue?vue&type=template&id=4e378d4c&scoped=true"
import script from "./LoginAccount.vue?vue&type=script&lang=js"
export * from "./LoginAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e378d4c",
  null
  
)

export default component.exports